import { useTranslation } from 'react-i18next';

import { AssetsService } from '../../services/AssetsService';
import { Button } from '../Button';

import type { EmptyStateVariant } from './styles';
import {
  StyledEmptyStateButtonWrapper,
  StyledEmptyStateContainer,
  StyledEmptyStateContent,
  StyledEmptyStateDescription,
  StyledEmptyStateImage,
  StyledEmptyStateTitle,
} from './styles';

type EmptyStateViewProps = {
  textKey?: string;
  messageKey?: string;
  buttonKey?: string;
  isButtonLoading?: boolean;
  img?: string;
  variant?: EmptyStateVariant;
  className?: string;
  onButtonClick?: VoidFunction;
};

export const EmptyStateView = ({
  textKey = 'company.empty_state.text',
  messageKey = 'company.empty_state.message',
  buttonKey,
  img = '/images/empty-state-girl.svg',
  variant = 'girl',
  className,
  isButtonLoading,
  onButtonClick,
}: EmptyStateViewProps) => {
  const { t } = useTranslation();

  return (
    <StyledEmptyStateContainer className={className}>
      <StyledEmptyStateImage src={AssetsService.assetUrl(img)} variant={variant} />

      <StyledEmptyStateContent>
        <StyledEmptyStateTitle data-automation="EmptyStateTitle">{t(textKey)}</StyledEmptyStateTitle>
        <StyledEmptyStateDescription data-automation="EmptyStateMessage">{t(messageKey)}</StyledEmptyStateDescription>
        {buttonKey ? (
          <StyledEmptyStateButtonWrapper>
            <Button variant="primary" onClick={isButtonLoading ? undefined : onButtonClick} isLoading={isButtonLoading}>
              {t(buttonKey)}
            </Button>
          </StyledEmptyStateButtonWrapper>
        ) : null}
      </StyledEmptyStateContent>
    </StyledEmptyStateContainer>
  );
};
